<template>
    <div>
        <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
            <el-row style="margin-bottom: 20px" v-if="$store.state.perms.perms">
                <el-button size="small" @click="getWarehouses()" :loading="loading"> 刷新</el-button>
            </el-row>
            
            <el-row :gutter="16">
                <el-col :span="12" v-for="wares in warehouses" :key="wares.id">
                     <CWaybillInfo :warehouse="wares"></CWaybillInfo>
                </el-col>
            </el-row>
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <Page :page-size="page.pageSize" show-total :total="page.total" :current="page.current" @on-change="changePage"></Page>
                </div>
            </div>
        </Content>
    </div>
</template>
<script>
import CWaybillInfo from "@/components/Index/CWaybillInfo"
export default {
    name: "Index",
    data() {
        return {
            queryParams: {

            },
            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
            warehouses: [

            ],
            loading: false,

        }
    },
    mounted: function() {
        this.userInfo = this.$store.state.user.userInfo;
        this.getWarehouses();
    },
    methods: {
        getWarehouses: function() {

            var me = this;
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;
            me.loading = true;
            me.$http.post("/ware/warehouse/getList.action", params).then(response => {
                var body = response;
                if (body.status == 0) {

                    me.warehouses = body.obj.list;
                    me.page.total = body.obj.totalCount;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        },
        changePage(current) {
            this.page.current = current;
            this.getList();
        },

    },
    components: {
        CWaybillInfo
    }
}
</script>
<style scoped>
.info-card {
    text-align: center;
    background-color: #fff;
    padding-bottom: 20px;
}

.info-card-count {

    font-size: 20px;
}

.left-area {
    float: left;
    height: 100%;
    width: 36%;
    display: table;
    text-align: center;
}

.info-card-wrapper .content-con {
    width: 100%;
    height: 100%;
    position: relative;
}

.info {
    height: 240px;
    overflow: hidden;
}

.notice {
    height: 240px;
    overflow: hidden;
}

.info li {
    list-style: none;
    line-height: 2;
    font-size: 16px;
}

.info.img {
    text-align: center;
}

.info.img img {
    height: 100%;

    overflow: hidden;
}

.notice li {
    line-height: 30px;
    height: 30px;
    border-bottom: 1px dotted #cecece;
    cursor: pointer;
}

.notice li:hover {
    color: #2d8cf0;
}

.notice-title {
    text-overflow: ellipsis;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    font-size: 14px;
    float: left;
    position: relative;


}

.notice-title.top {
    color: #2d8cf0;
}

.notice-title font {
    margin-right: 5px;
}

.noticetitle {
    font-size: 18px;
    text-align: center;

    line-height: 20px;
    font-family: "微软雅黑";
    margin: 0px auto;
    clear: both;

    padding-bottom: 15px;
}

.noticecontent {
    font-size: 16px;
    text-align: center;
    text-align: left;
    line-height: 20px;
}
</style>